export default __webpack_public_path__ + "static/media/student.b2d7f3db.png";